import { IslandsDataIn } from './types';
import { RecordData } from '../../helpers-classes';

export const islandsData = (dataIn: IslandsDataIn = null): IslandsDataIn => {
	const rd = new RecordData<IslandsDataIn>(dataIn);

	const record: IslandsDataIn = {
		defaultIslandId: rd.useNewOrDefault<string | null>('defaultIslandId', null),
		children: dataIn?.children ?? []
	};

	return record;
};
